import React from 'react';
import { AppBar } from '@material-ui/core';
import MainHeader from './MainHeader';
import ButtonHeader from './ButtonHeader';
import { useHeaderStyles } from './styles';

const Header = () => {
  const classes = useHeaderStyles();
  return (
    <React.Fragment>
      <AppBar className={classes.mainRoot} elevation={0} position="static">
        <ButtonHeader />
        <MainHeader />
      </AppBar>
    </React.Fragment>
  );
};

export default Header;
